import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Button } from '@vnetwork/ui/primitives';
import { ResellerDashboardSection } from './components/reseller-dashboard-section';
import { ResellerListSection } from './components/reseller-list-section';

// NOTE: Legacy "Pending Confirmation" (reseller candidates) tab is deferred —
// the deployed `GET /contacts/by-role` returns 400 `invalid-contact-source-id`,
// a requirement not present in the current @api source (deployed ≠ local repo),
// so the contract can't be resolved from the frontend. Do not ship a broken tab.

/**
 * `/resellers` — list page: dashboard stats + top-resellers table, then the
 * full paginated reseller list with search + tier/status filters. Mirrors the
 * legacy `Reseller/components/List` structure.
 */
export default function ResellersPage() {
  const navigate = useNavigate();

  return (
    <Container size="full">
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <PageHeader
          title="Resellers"
          description="Manage official resellers and track their performance."
          actions={
            <Button
              variant="primary"
              startIcon={<Plus size={15} />}
              onClick={() => navigate('/resellers/new')}
            >
              Add Reseller
            </Button>
          }
        />

        <ResellerDashboardSection />

        <ResellerListSection />
      </div>
    </Container>
  );
}
